import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../../utils/api";
import { calculateQuotaPercentageEndpoint } from "../../../common/endpoints";

export const calculateQuotaPercentage = createApi(
  calculateQuotaPercentageEndpoint,
  "POST",
);

const CalculateQuota = createSlice({
  name: "CalculateQuota",
  initialState: { data: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(calculateQuotaPercentage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(calculateQuotaPercentage.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(calculateQuotaPercentage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default CalculateQuota.reducer;